











export default {
  props: {
    showIcon: { type: Boolean, default: true },
    loadWeight: { type: [String, Number], default: null },
    enableAutoFormatting: { type: Boolean, default: true }
  },
  computed: {
    formattedLoadWeight() {
      const suffix = this.enableAutoFormatting ? 't' : ''
      return this.loadWeight ? `${this.loadWeight}${suffix}` : '-'
    }
  }
}
